module.exports = "/templates/taskadd.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/taskadd.html
// module id = 467
// module chunks = 0